<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { computed } from "vue"
import { NotificationType } from "./NotificationInterface"
import type { OptionsType, ActionType } from "./NotificationInterface"
import InfoIcon from "@/assets/icons/info.svg?component"
import WarningIcon from "@/assets/icons/warning.svg?component"
import CancelIcon from "@/assets/icons/cancel.svg?component"
import ErrorIcon from "@/assets/icons/error.svg?component"
import DoneIcon from "@/assets/icons/done.svg?component"

const props = defineProps<{
   type: NotificationType
   text?: string
   action?: ActionType
   options?: OptionsType
}>()

const notificationClass = computed(() => ({
   "notification--info": props.type === NotificationType.Info,
   "notification--warning": props.type === NotificationType.Warning,
   "notification--error": props.type === NotificationType.Error,
   "notification--success": props.type === NotificationType.Success,
   "notification--cancel": props.type === NotificationType.Cancel
}))

const getType = computed(() => {
   switch (props.type) {
      case NotificationType.Success:
         return DoneIcon
      case NotificationType.Warning:
         return WarningIcon
      case NotificationType.Error:
         return ErrorIcon
      case NotificationType.Cancel:
         return CancelIcon
      default:
         return InfoIcon
   }
})
</script>

<template>
   <div
      class="notification"
      :class="[options?.notification_class, notificationClass]"
   >
      <div class="notification--wrapper">
         <component
            :is="getType"
            class="notification--icon"
            :class="options?.icon_class"
         />
         <div class="notification--text" :class="options?.text_class">
            {{ text }}
         </div>
      </div>
      <div
         v-if="action"
         class="notification--action"
         :class="options?.action_class"
         @click="action?.callback"
      >
         {{ action?.label }}
      </div>
   </div>
</template>
